import React from "react";
import logoLight from "../Assets/Images/inssure-logo.svg";
import logoDark from "../Assets/Images/inssure-logo-dark.svg";

export default function InssureLogo({ className = "", alt = "inSure" }) {
  const cls = ["ems-logo-theme", className].filter(Boolean).join(" ");
  return (
    <>
      <img src={logoLight} alt={alt} className={`ems-logo-light ${cls}`} />
      <img src={logoDark} alt="" aria-hidden="true" className={`ems-logo-dark ${cls}`} />
    </>
  );
}
